import styled from 'styled-components';

export const InputsWrapper = styled.div`
  display: flex;
  gap: 12px;
  width: 100%;

  flex: 1;
`;

export const DocumentInputWrapper = styled.div`
  display: flex;
  gap: 8px;
  width: 100%;
  align-items: flex-end;

  .type-selector {
    min-width: 140px;

    .ant-form-item {
      margin-bottom: 0;
    }
  }

  .number-input {
    flex: 1;

    .ant-form-item {
      margin-bottom: 0;
    }
  }
`;

export const SectionTitle = styled.h3`
  font-size: 16px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.black9};
  margin-bottom: 16px;
  margin-top: 24px;

  &:first-child {
    margin-top: 0;
  }
`;

export const FieldLabel = styled.span`
  font-size: 14px;
  color: ${({ theme }) => theme.colors.black9};

  .required {
    color: ${({ theme }) => theme.colors.red6};
  }
`;

export const AddressInputsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  margin-bottom: 12px;

  .ant-form-item {
    margin-bottom: 0;
  }
`;
